//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Result',
  data() {
    return {
      openid: '',
      lotteryRecordId: '',
      lotteryProjectCode: '',
      prizeName: '',
      prizeImg: '',
      prizeCode: '',
      prizeAddress: '',
      prizeStatus: '',
      prizeQrTicket: '',
      prizeIsWin: 0,
      hasError: false
    }
  },
  computed: {
    qrUrl() {
      return `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${this.prizeQrTicket}`
    }
  },
  mounted() {
    this.getUrlParams()
    this.getLotteryRecord()
  },
  methods: {
    getLotteryRecord() {
      let that = this;
      let url = '/lottery/record/getLotteryRecordById';
      that.$axios.post(url, null, {params: {lotteryProjectCode: that.lotteryProjectCode, id: that.lotteryRecordId}}).then(function (res) {
        if (res.meta.success) {
          let lotteryRecord = res.data;
          if (lotteryRecord && lotteryRecord.id) {
            that.prizeName = lotteryRecord.prize_name || ''
            that.prizeImg = lotteryRecord.prize_image || ''
            that.prizeCode = lotteryRecord.verify_code || ''
            that.prizeStatus = (Number(lotteryRecord.verify_status) || 0) === 0 ? '未核销' : '已核销'
            that.prizeQrTicket = lotteryRecord.verify_code_qr_ticket || ''
            that.prizeIsWin = Number(lotteryRecord.is_win) || 0

            that.hasError = false
          } else {
            that.hasError = true
          }
        } else {
          that.hasError = true
          that.$Message.error(res.meta.message);
        }
      });
    },
    // 获取URL参数
    getUrlParams() {
      const params = new URLSearchParams(window.location.search)
      this.lotteryRecordId = params.get('id') || ''
      this.openid = params.get('openid') || ''
      this.prizeAddress = params.get('address') || ''
      this.lotteryProjectCode = params.get('lotteryProjectCode') || ''
    },
    // 图片加载失败处理
    handleImgError(e) {
      const firstChar = this.prizeName.charAt(0)
      e.target.src = `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22120%22%20height%3D%22120%22%20viewBox%3D%220%200%20120%20120%22%3E%3Crect%20width%3D%22120%22%20height%3D%22120%22%20fill%3D%22%23d35400%22%2F%3E%3Ctext%20x%3D%2260%22%20y%3D%2260%22%20font-size%3D%2240%22%20fill%3D%22%23fff%22%20text-anchor%3D%22middle%22%20dominant-baseline%3D%22middle%22%3E${firstChar}%3C%2Ftext%3E%3C%2Fsvg%3E`
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/lottery/Result.vue